<template>
  <div class="ui-content dashboard leader-sub custom-testJan31">
    <div class="search-test-name-assigment customsearchbox">
      <div class="search-test-name">
        <v-text-field
          v-model="search"
          @keydown="onSearch()"
          solo
          label="Test Name"
          dense
          outlined
          hide-details
          append-icon="search"
          autocomplete="off"
        ></v-text-field>
      </div>
    </div>
    <div>
      <ImprovementAssignmentsTestsList :search="searchText" :onSearch="onSearch"/>
    </div>
  </div>
</template>

<script>
import ImprovementAssignmentsTestsList from "@/components/student/Tests/PastTests/ImprovementAssignmentsTestsList.vue";
// import PreviousYearTest from "@/components/student/Tests/PastTests/PreviousYearTest.vue";
import { mapState, mapMutations } from "vuex";
export default {
  name: "ImprovementAssignments",
  components: {
    ImprovementAssignmentsTestsList,
  },
  mounted() {},
  computed: {
    ...mapState("userStore", ["user"]),
  },
  data() {
    return {
      searchText: "",
      search: "",
    };
  },
  methods: {
    ...mapMutations("app", ["addBreadCrumbChilde"]),
    onSearch() {
      let routeName = this.$route.name;

      if (this.typetimeout) {
        clearTimeout(this.typetimeout);
      }
      this.typetimeout = setTimeout(() => {
        this.searchText = this.search;
        let updatedDetails = { searchText: this.searchText };
        updatedDetails.routeName = routeName;
        this.setRouteDetails(updatedDetails);
      }, 1500);
    },
  },
};
</script>
